import { useContext, type FunctionComponent } from 'react';
import classNames from 'classnames';
import GlobalNavInternalContext, { Timer } from '../../context/GlobalNavInternalContext';
import NewMemberNav from '../NMF/NewMemberNav';
import './Header.css';
import NavToast from '../Toast';
import NMFHeaderContent from './NMFHeaderContent';

type NMFHeaderProps = {
  step: string;
  isEditCampaignOpen: boolean;
  endTime: Timer['endTime'] | undefined;
  timerSource: Timer['timerSource'] | undefined;
};

const NMFHeader: FunctionComponent<NMFHeaderProps> = ({
  step,
  isEditCampaignOpen,
  timerSource,
}) => {
  const { env: globalEnv } = useContext(GlobalNavInternalContext);

  const skipCustomize = timerSource === 'introProduct' || timerSource === 'publicCustomize';

  const hideBoostNode = !isEditCampaignOpen;
  // Hide the customize node for FC on GTB
  const hideCustomizeNode = skipCustomize;

  return (
    <>
      <div
        className={classNames('header', {
          header__nmf: true,
        })}
        data-testid="NMFHeader"
      >
        <div className="header__wrapper">
          <NMFHeaderContent env={globalEnv} />
        </div>
      </div>
      <NewMemberNav
        step={step}
        hideCustomizeNode={hideCustomizeNode}
        hideBoostNode={hideBoostNode}
      />
      <NavToast loggedIn />
    </>
  );
};

export default NMFHeader;
